// extracted by mini-css-extract-plugin
export default {"header":"Heading_header__AjaiW","color_dark-blue":"Heading_color_dark-blue__fhclm","color_dark-gray":"Heading_color_dark-gray__VVbNE"};